import React, { useState } from 'react';
import { Link, useHistory, Redirect } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaRegEnvelope } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDataContext } from '../Context/dataContext';
import logo from '../Assets/Images/remesalogo.png';
import recoverImage from '../Assets/Images/loginn.jpg'; // Imagen lateral igual al login/register

function Recover() {
  const { logged, url } = useDataContext();
  const history = useHistory();
  const [to, setTo] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await fetch(`${url}/Mailer/emailRecovery/${to.toLowerCase()}`, { method: 'POST' });
      toast.success('El correo fue enviado con éxito');
      setTimeout(() => {
        history.push('/Login');
      }, 3000);
    } catch (error) {
      toast.error('Hubo un error al enviar el correo');
    } finally {
      setLoading(false);
      setTo('');
    }
  };

  if (logged) return <Redirect to="/Changes" />;

  return (
    <div className="recover-page">
      <div className="recover-container">
        <div className="recover-image">
          <img src={recoverImage} alt="Recuperación visual" />
        </div>

        <motion.div
          className="recover-form-wrapper"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/">
            <motion.img
              src={logo}
              alt="Remesa España"
              className="recover-logo"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </Link>

          <form className="recover-form" onSubmit={handleSubmit}>
            <label>
              <FaRegEnvelope className="icon" />
              <input
                type="email"
                placeholder="Correo electrónico"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                required
              />
            </label>

            <button type="submit" className="recover-button" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar correo de recuperación'}
            </button>

            <Link to="/Login" className="recover-back">
              ¿Ya tienes cuenta? Inicia sesión
            </Link>

            <Link to="/Register" className="recover-back">
              ¿No tienes cuenta? Regístrate
            </Link>
          </form>
        </motion.div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export { Recover };
